import { injectable, injectFromBase } from 'inversify'
import { RepoSettings } from '@/decorators/repositoryDecorators'
import type { Endpoint } from '@/services/endpoints'
import OrmApiRepository from '@/data/repositories/ormApiRepository'
import MarketingData from '@/data/models/domain/MarketingData'
import type { MarketingDataResponse, MarketingDataSubmitPayload } from '@/services/domain/marketingData/types'
import { TmIncorrectContractError } from '@/core/error/tmIncorrectContractError'

@RepoSettings<Endpoint>({
  model: MarketingData,
})
@injectable()
@injectFromBase()
export default class MarketingDataRepository extends OrmApiRepository<MarketingData> {
  private readonly id = '1'

  public async fetchMarketingData(): Promise<MarketingData | null> {
    const path = this.endpointsService.getPath('userMarketingData')
    const response = await this.getApiSource().get<MarketingDataResponse>(path)

    if (!response.data) {
      throw new TmIncorrectContractError('Response data expected')
    }

    await this.insertOrUpdate([{ id: this.id, ...response.data }])
    return this.findEntityByIdOrFail(this.id)
  }

  public getMarketingData(): MarketingData | null {
    return this.findEntityByIdOrNull(this.id)
  }

  public async saveMarketingData(payload: MarketingDataSubmitPayload): Promise<void> {
    const path = this.endpointsService.getPath('userMarketingData')
    await this.getApiSource().post(path, payload)
  }

  public async skipMarketingData(): Promise<void> {
    const path = this.endpointsService.getPath('userMarketingDataSkip')
    await this.getApiSource().post(path)
  }
}
